import { useEffect, useState } from 'react';
import Person from './Person';
import firebase from 'firebase';
import 'firebase/firestore';

const Search = () => {
	const phone = localStorage.getItem('user-phone');
	const firestore = firebase.firestore();
	const [people, setPeople] = useState([]);
	const [searchResult, setSearchResult] = useState([]);
	const [togglePeople, setTogglePeople] = useState(false);
	const allPeople = firestore.collection(`users`);

	useEffect((e) => {

		function getPeople() {
			const array = [];

			allPeople.get().then((docs) => {
				docs.forEach((snap) => {
					const data = snap.data();

					const user = {
						dp: data.dp,
						name: data.name,
						phone: data.phone,
						caption: data.caption,
						createdAt: data.createdAt,
					};

					data.phone !== phone && array.push(user);
					setPeople([...people, ...array]);
				});
			});
		}

		if (phone !== null) {
			getPeople();
		}
	}, []);

	return (
		<div className="search-page page">
			<div className="top flex-col-evenly">
				<h2>search</h2>
				<input
					type="search"
					placeholder="Search for "
					onChange={(e) => {
						var ul = document.getElementById('people-ul');
						const result = people.filter((a) =>
							a.name.toLowerCase().includes(e.target.value.toLowerCase())
						);
						setSearchResult(result);
						setTogglePeople(true);
					}}
				/>
			</div>
			<div className="center ">
				<ul id="people-ul" className="flex-col-start">
					{togglePeople &&
						searchResult.map((a) => {
							return <Person key={a.phone} name={a.name} phone={a.phone} dp={a.dp} caption={a.caption} />;
						})}
					{togglePeople === false &&
						people.map((a) => {
							return <Person key={a.phone} name={a.name} phone={a.phone} dp={a.dp} caption={a.caption} />;
						})}
				</ul>
			</div>
		</div>
	);
};

export default Search;
